<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-11-13 11:21:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-23 15:01:51
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/goodsFilter.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="mt-24">
        <div class="goods-table-head flex">
			<div class="table-head-list mr-32 pointer" v-for="(item, index) in sort_type" :key="index" @click="onTabClick(item, index)">
				<span :class="['fz-13', 'head-name', item.sort ? 'active-text' : '']">{{ item.name }}</span>
				<img class="icon-img" v-if="item.showIcon && !item.sort" src="@/assets/public/sort_default.png" alt="" />
				<img class="icon-img" v-if="item.showIcon && item.sort" src="@/assets/public/sort_active.png" alt="" />
			</div>
		</div>
    </div>
</template>
<script>
export default{
	props:{
		platformId: {
			type: Number,
			default: +dataMap.PLATFORM_DY.value,
		},
	},
    data(){
        return{
            sort_type: newDataMap.SHOP_MANAGE.COMMERCIAL_HIGH_SEAS_LIST,
        }
    },
	watch:{
		platformId:{
			handler(){
				this.onClear();
			},
			immediate: true,
		}
	},
    methods:{
        onTabClick(item, index) {
			this.sort_type.map(val => val.sort = false);
			if (!item.sort) {
				this.sort_type[index].sort = true;
			}
            this.$emit('change',item.key)
		},
		onClear(){
			this.sort_type.map((val)=>{
				val.sort = false;
				if(val.key === 'orderNum'){
					val.sort = true
				}
			})
		},
    }
}
</script>
<style lang="less" scoped>
.goods-table-head {
		border-radius: 8px;
		padding: 12px;
		background: @background-color-base;
		.table-head-list {
			display: flex;
			align-items: center;
			.head-name {
				color: @color-gy7;
				font-family: 'PingFangSC-Medium';
			}
			.icon-img {
				margin-left: 4px;
				width: 12px;
				height: auto;
			}
			.active-text {
				color: @color-p;
			}
		}
	}
</style>